import { cart } from './cart.i18n';

export const en = {
  cart,
};
